import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React, { createRef, useEffect, useMemo } from 'react';
import { Modal } from "../modal/Modal.js";
import { ModalContent } from "../modal/components/modalContent/ModalContent.js";
import { ModalFooter } from "../modal/components/modalFooter/ModalFooter.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Dialog = ({
  id,
  title,
  children,
  onCancel,
  onConfirm,
  onSecondaryConfirm,
  onClose,
  cancelButtonCaption,
  confirmButtonCaption,
  secondaryConfirmButtonCaption,
  className,
  confirmDisabled,
  refDocument = typeof window !== 'undefined' ? window.document : undefined
}) => {
  const ref = /*#__PURE__*/createRef();
  useEffect(() => {
    const backdropRef = ref.current;
    if (!backdropRef) {
      return;
    }
    disableBodyScroll(backdropRef);
    return () => enableBodyScroll(backdropRef);
  }, [ref]);
  const modalActions = useMemo(() => {
    return [cancelButtonCaption ? {
      semantic: 'CANCEL',
      handler: onCancel,
      label: cancelButtonCaption
    } : undefined, secondaryConfirmButtonCaption && onSecondaryConfirm ? {
      semantic: 'SECONDARY',
      handler: onSecondaryConfirm,
      label: secondaryConfirmButtonCaption
    } : undefined, {
      semantic: 'SUBMIT',
      handler: onConfirm,
      disabled: confirmDisabled,
      label: confirmButtonCaption
    }].filter(Boolean);
  }, [cancelButtonCaption, confirmButtonCaption, confirmDisabled, onCancel, onConfirm, onSecondaryConfirm, secondaryConfirmButtonCaption]);
  return /*#__PURE__*/_jsxs(Modal, {
    id: id,
    closeable: true,
    close: onClose,
    title: title,
    role: "alertdialog",
    size: "S",
    closeOnOverlayClick: true,
    refDocument: refDocument,
    children: [/*#__PURE__*/_jsx(ModalContent, {
      className: className,
      children: children
    }), /*#__PURE__*/_jsx(ModalFooter, {
      actions: modalActions
    })]
  });
};